import React, { useState } from 'react';
import './VirtualCFO.css';

function CorporateLaw() {
  const [activeIndex, setActiveIndex] = useState(null);

  const offerings = [
    {
      title: 'Company Law Advisory',
      content: [
        'Company incorporation and conversion',
        'Advisory on Companies Act, 2013 compliance',
        'Board meeting and general meeting support',
        'Drafting resolutions and notices',
      ],
    },
    {
      title: 'ROC Compliances',
      content: [
        'Filing of annual returns and financial statements',
        'Event-based ROC filings (DIR-12, MGT-7, AOC-4, etc.)',
        'Maintaining statutory registers and records',
        'Compliance calendar management',
      ],
    },
    {
      title: 'Secretarial Audits',
      content: [
        'Internal secretarial audit for private and public companies',
        'Compliance health check and gap analysis',
        'Assistance in CS certification and reports',
        'Audit-ready documentation and filing',
      ],
    },
    {
      title: 'Legal Documentation',
      content: [
        'Drafting shareholder agreements and MoUs',
        'Non-disclosure agreements and vendor contracts',
        'Employment and consultancy contracts',
        'Policy drafting for internal governance',
      ],
    },
    {
      title: 'Regulatory Approvals',
      content: [
        'Change in directors, share capital, registered office',
        'DIN application, name change, and strike-off procedures',
        'Support with SEBI, RBI, MCA, and NCLT procedures',
        'Assistance with LLP compliance and closures',
      ],
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/corporate_law_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Corporate Law & Secretarial</h1>
          <p>Comprehensive ROC compliance and legal advisory for corporate governance</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Legal Clarity and Compliance</h2>
          <p>We handle company incorporation, board resolutions, annual filings, and secretarial audits with precision.</p>
          <p>Our CS and legal experts ensure your organization is aligned with MCA, SEBI, and other corporate law requirements.</p>
          <p>Whether you're a startup or public company, we keep your documents and decisions compliant, timely, and transparent.</p>
        </div>
      </section>

      {/* Accordion Section */}
      <section className="accordion-section">
        <h2>Our Offerings</h2>
        <div className="accordion-container">
          {offerings.map((item, index) => (
            <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
              <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                <span>{activeIndex === index ? '−' : '+'}</span> {item.title}
              </div>
              {activeIndex === index && (
                <div className="accordion-body">
                  <ul>
                    {item.content.map((point, idx) => (
                      <li key={idx}>{point}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default CorporateLaw;


